var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.366961 0.373533C0.854022 -0.124511 1.63729 -0.124511 2.12435 0.373533L7.50029 5.90207L12.8762 0.373533C13.3633 -0.124511 14.1465 -0.124511 14.6336 0.373533C14.8687 0.613775 15.0007 0.941699 15 1.28367C15.0009 1.62552 14.8688 1.95335 14.6336 2.19322L8.37927 8.62477C8.14626 8.86612 7.82986 9.00118 7.50029 8.99999C7.1709 9.00109 6.85471 8.86603 6.62188 8.62477L0.366387 2.19322C0.131378 1.9532 -0.000638777 1.62547 1.90735e-06 1.28367C-0.000254893 0.941666 0.131925 0.613829 0.366961 0.373533V0.373533Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectImg);
export default __webpack_public_path__ + "static/media/SelectImg.c9affb1cc5920edade8bdbfb61cdf289.svg";
export { ForwardRef as ReactComponent };